import React from 'react';
import Cookies from 'js-cookie';

export default class DjangoCSRFToken extends React.Component {

  render(){

    var csrfToken = Cookies.get('csrftoken');

    return (
      <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/djangocrsf.js